import { render, staticRenderFns } from "./prescription_form.vue?vue&type=template&id=7f206a86"
import script from "./prescription_form.vue?vue&type=script&lang=js"
export * from "./prescription_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports